import { render, staticRenderFns } from "./transferCash.vue?vue&type=template&id=36230a99&lang=pug&"
import script from "./transferCash.vue?vue&type=script&lang=js&"
export * from "./transferCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports